export const SEGREGATION_TERMS = 'SEGREGACAO_TERMO';
export const SEGREGATION_TOOLTIP = 'SEGREGACAO_TOOLTIP';
export const MAINTENANCE_SITE_CREDENCIAMENTO =
  'MAINTENANCE_SITE_CREDENCIAMENTO';
